import { truncate } from 'lodash-es';
import React, { FC } from 'react';
import LinesEllipsis from 'react-lines-ellipsis';

interface Props {
  text?: string;
  maxLettersPerLine?: number;
  maxLines?: number;
}

const Ellipsis: FC<Props> = ({ text = '', maxLettersPerLine = 14, maxLines = 3 }) => {
  const ellipsisLongWords = (sentence: string): string => {
    const words = sentence.split(' ');
    const trimmedWords = words.map(word => truncate(word, { length: maxLettersPerLine, omission: '...' }));
    return trimmedWords.join(' ');
  };

  return <LinesEllipsis text={ellipsisLongWords(text)} maxLine={maxLines} ellipsis='...' trimRight basedOn='letters' />;
};

export default Ellipsis;
